import { create } from 'zustand';
import { Plan } from '@/features/plans/types';

interface PlanState {
  selectedPlan: Plan | null;
  isCreateModalOpen: boolean;
  isDeleteModalOpen: boolean;
  isFeatureEditorOpen: boolean;
  setSelectedPlan: (plan: Plan | null) => void;
  openCreateModal: () => void;
  closeCreateModal: () => void;
  openDeleteModal: () => void;
  closeDeleteModal: () => void;
  openFeatureEditor: () => void;
  closeFeatureEditor: () => void;
}

export const usePlanStore = create<PlanState>((set) => ({
  selectedPlan: null,
  isCreateModalOpen: false,
  isDeleteModalOpen: false,
  isFeatureEditorOpen: false,
  setSelectedPlan: (plan) => set({ selectedPlan: plan }),
  openCreateModal: () => set({ isCreateModalOpen: true }),
  closeCreateModal: () => set({ isCreateModalOpen: false }),
  openDeleteModal: () => set({ isDeleteModalOpen: true }),
  closeDeleteModal: () => set({ isDeleteModalOpen: false }),
  openFeatureEditor: () => set({ isFeatureEditorOpen: true }),
  closeFeatureEditor: () => set({ isFeatureEditorOpen: false })
})); 